module.exports = __webpack_public_path__ + "5421ded16268d298c2b06a52d3b9ce27.svg";